import { initialsFor } from './gameUtils';

// Club badge. Uses the uploaded badge image when there is one, otherwise a
// colour shield with the club's initials — the same placeholder approach as
// the marketing carousel, so a badge-less club still reads as itself.
export default function ClubCrest({ club, size = 44, radius }) {
  const r = radius != null ? radius : Math.round(size * 0.18);
  if (club && club.badge_url) {
    return (
      <img
        src={club.badge_url}
        alt={`${club.name} badge`}
        width={size}
        height={size}
        style={{ display: 'block', objectFit: 'contain', borderRadius: r }}
      />
    );
  }
  const primary = (club && club.primary_color) || '#2A2740';
  const secondary = (club && club.secondary_color) || '#F2F4FA';
  return (
    <div
      aria-hidden="true"
      style={{
        width: size, height: size, borderRadius: r, flexShrink: 0,
        background: primary,
        border: `2px solid ${secondary}`,
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        color: secondary,
        fontFamily: "'Chakra Petch', sans-serif",
        fontWeight: 700,
        fontSize: Math.round(size * 0.34),
        letterSpacing: '0.02em',
        boxSizing: 'border-box',
      }}
    >
      {initialsFor(club && club.name)}
    </div>
  );
}
